module.exports = __webpack_public_path__ + "static/media/Nunito-SemiBold.4f5c7af2.woff";